<template>
	<div v-if="props.enroll.is_first_license_course" class="col-sm-12 col-lg-4">
		<div class="card card-custom card-stretch gutter-b">
			<div class="card-body shadow-sm">
				<div
					class="d-flex justify-content-between flex-column pt-4 h-100">
					<div class="pb-5">
						<div class="d-flex flex-column flex-center">
							<div class="symbol symbol-80 symbol-light-danger">
								<span class="symbol-label">
									<img
										src="/habil/images/favicon.png"
										class="h-50 align-self-center"
										alt="Logo Habilite-se" />
								</span>
							</div>
							<a
								:href="enroll.course_classroom_url"
								class="card-title font-weight-bolder h4 text-primary mt-7 mb-1 text-center">
								{{
									enroll.subtenant_course?.course?.description
								}}
							</a>
							<div class="text-muted text-center mt-1">
								{{ enroll.subtenant_course.subtenant.name }}
							</div>
							<div
								v-if="enroll.last_access !== undefined"
								class="text-muted mt-1">
								Último acesso:
								{{
									new Date(enroll.last_access).toLocaleString(
										'pt-br'
									)
								}}
							</div>
							<div v-else class="text-muted mt-1">
								Ainda não acessados
							</div>
						</div>
						<div class="pt-1 mt-2">
							<div
								class="d-flex align-items-center justify-content-between mb-3 w-100">
								<div class="text-muted font-weight-bold mr-2">
									Progresso
								</div>
								<div class="text-muted font-weight-bold">
									{{ enroll.content_progress }} %
								</div>
							</div>
							<div class="d-flex flex-column w-100">
								<div class="progress progress-xs w-100">
									<div
										:class="{
											'progress-bar bg-success':
												enroll.content_progress >= 50,
											'progress-bar bg-danger':
												enroll.content_progress < 50,
										}"
										role="progressbar"
										:style="{
											width:
												enroll.content_progress + '%',
										}"
										:aria-valuenow="`${enroll.content_progress}`"
										aria-valuemin="0"
										aria-valuemax="100"></div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="not_have_config_webcam_mic"
						class="d-flex flex-column">
						<a
							href="/dashboard/config-first-license"
							class="btn btn-primary btn-sm btn-block">
							Configurar para aulas online
							<i class="fas fa-arrow-right ml-2"></i>
						</a>
					</div>
					<div v-else>
						<div
							class="d-flex flex-column"
							v-if="auth_user.student_taken_login_photo">
							<a
								v-if="props.enroll.zoom_class_url"
								:href="props.enroll.zoom_class_url"
								class="btn btn-primary btn-sm btn-block mb-2">
								Assistir aula
								<i class="fas fa-arrow-right ml-2"></i>
							</a>
							<a
								:href="props.enroll.course_classroom_url"
								class="btn btn-primary btn-sm btn-block mb-2">
								Ir para lista de aulas
								<i class="fas fa-arrow-right ml-2"></i>
							</a>
							<a
								:href="getMaterialUrl()"
								class="btn btn-success btn-sm btn-block mb-2">
								Baixar material
								<i class="fas fa-file-pdf ml-2"></i>
							</a>
							<a
								v-if="enroll.content_progress == 100"
								:href="`/dashboard/enroll/${props.enroll.id}/mockTests`"
								class="btn btn-info btn-sm btn-block">
								Acessar simulado final
								<i class="fas fa-book ml-2"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		v-else-if="props.enroll.tenant_course.allow_student_area"
		class="col-sm-12 col-lg-4">
		<div class="card card-custom card-stretch gutter-b">
			<div class="card-body shadow-sm">
				<div
					class="d-flex justify-content-between flex-column pt-4 h-100">
					<div class="pb-5">
						<div class="d-flex flex-column flex-center">
							<div class="symbol symbol-80 symbol-light-danger">
								<span class="symbol-label">
									<img
										src="/habil/images/favicon.png"
										class="h-50 align-self-center"
										alt="Logo Habilite-se" />
								</span>
							</div>
							<a
								:href="enroll.course_modules_url"
								class="card-title font-weight-bolder h4 text-primary mt-7 mb-1 text-center">
								{{
									enroll.subtenant_course?.course?.description
								}}
							</a>
							<div class="text-muted text-center mt-1">
								{{ enroll.subtenant_course.subtenant.name }}
							</div>
							<div
								v-if="enroll.last_access !== undefined"
								class="text-muted mt-1">
								Último acesso:
								{{
									new Date(enroll.last_access).toLocaleString(
										'pt-br'
									)
								}}
							</div>
							<div v-else class="text-muted mt-1">
								Ainda não acessados
							</div>
						</div>
						<div class="pt-1 mt-2">
							<div
								class="d-flex align-items-center justify-content-between mb-3 w-100">
								<div class="text-muted font-weight-bold mr-2">
									Progresso
								</div>
								<div class="text-muted font-weight-bold">
									{{ enroll.content_progress }} %
								</div>
							</div>
							<div class="d-flex flex-column w-100">
								<div class="progress progress-xs w-100">
									<div
										:class="{
											'progress-bar bg-success':
												enroll.content_progress >= 50,
											'progress-bar bg-danger':
												enroll.content_progress < 50,
										}"
										role="progressbar"
										:style="{
											width:
												enroll.content_progress + '%',
										}"
										:aria-valuenow="`${enroll.content_progress}`"
										aria-valuemin="0"
										aria-valuemax="100"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex flex-column">
						<a
							id="go-to-class"
							v-if="auth_user.student_taken_login_photo"
							:href="props.enroll.course_modules_url"
							class="btn btn-primary btn-sm btn-block mb-2">
							Acessar curso
							<i class="fas fa-graduation-cap ml-2"></i>
						</a>
						<a
							:href="getMaterialUrl()"
							class="btn btn-success btn-sm btn-block">
							Baixar material <i class="fas fa-file-pdf ml-2"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { usePage } from '@inertiajs/vue3';
	import { AuthUser } from 'resources/js/Interfaces/AuthUser';

	const props = defineProps({
		enroll: { type: Object, required: true },
		courses_file: { type: Object, required: true },
		url_bucket: { type: String, required: true },
	});

	const auth_user = usePage().props?.auth_user as AuthUser;
	var not_have_config_webcam_mic = !localStorage.getItem(
		'config_first_license'
	);

	function getMaterialUrl(): string {

		switch (props.enroll.tenant_course.course.id) {
			case 1:
				return `${props.url_bucket}/apostilas/01-apostila-reciclagem-infratores.pdf`;
			case 4:
				return `${props.url_bucket}/apostilas/02-renovacao-da-cnh.pdf`;
			case 5:
				return `${props.url_bucket}/apostilas/05-apostila_primeira_habilitacao.pdf`;
			case 11:
				return `${props.url_bucket}/apostilas/01-apostila-reciclagem-infratores.pdf`;
			default:
				return '#';
		}
	}
</script>
